// extracted by mini-css-extract-plugin
export default {"form":"EventForm_form__C4hdo","actions":"EventForm_actions__InDJG"};